module.exports = __webpack_public_path__ + "img/stop_here.1ec8587e.svg";